<template>
  <v-container v-if="!isLoading">
    <v-card 
      :color="data.MainColor"
      class="pa-1 mx-auto" 
      max-width="1024" 
      elevation="24">
        <v-card>
          <v-container >
            <v-row align="center" justify="center">
                <v-col class="pt-5">
                    <v-col cols="12">
                    <v-img
                        :src="data.Logo"
                        class="my-1"
                        contain
                        height="200"
                        elevation="24"
                    />
                    </v-col>
                </v-col>
            </v-row>
            <div v-html="data.Title" class="ma-2" align="center" justify="center"></div>
            <div v-html="data.Description" class="ma-2" align="start" justify="start"></div>
            <v-stepper :value="currentStep">
              <v-stepper-header>
                <template v-for="(step, index) in data.steps">
                  <v-stepper-step :step="step.stepno">
                    {{ step.title }} 
                  </v-stepper-step>
                  <v-divider v-if="index < (data.steps.length)"></v-divider>
                </template>
              </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content
                v-for="(step) in data.steps"
                :key="step.stepno"
                :step="step.stepno"
              >
              <div v-html="step.information" class="ma-2" align="start" justify="start">
              </div>
                <v-form 
                  ref="stepForm" 
                  v-model="step.valid" 
                  lazy-validation 
                  @submit.prevent>
                    <v-form-base 
                        id="form-base-slot"
                        :model="step.Model" 
                        :schema="step.Schema" 
                        :col="{ cols:12, sm:6, md:6, lg:6 }"
                        @click="log"
                        @input="handleInput">
                        <!-- 
                        Event Handlers that can be added in to v-form-base
                          @input="handleInput"
                          @click="log" 
                        see methods below for examples
                        -->
                        <!-- FORM SLOTS -->
                        <!-- <template #slot-top-form-base-slot>   
                          <h4 class="slot">
                            Top Slot of 'Form'
                          </h4>
                        </template> -->
                        <!-- <template #slot-bottom-form-base-slot>
                          <h4 class="slot">
                            Bottom Slot of 'Form'
                          </h4>  
                        </template> -->
                        </v-form-base>
                    
                </v-form>
                <v-row class="ma-1">
                    <v-btn 
                      outlined
                      :color="data.MainColor"
                      class="ma-2 mt-2"
                      dark
                      depressed
                      elevation="5"
                      @click="previous" v-if="step.stepno > 1 && step.stepno != data.steps.length && (step.backBtn === 'NO' ? false : true)" >
                      Back</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                      outlined
                      :color="data.MainColor"
                      class="ma-2 mt-2"
                      dark
                      depressed
                      elevation="5"
                      @click="validateStepForm(step.stepno -1)" 
                      v-if="step.stepno > 1 && step.stepno < (data.steps.length -1) && (step.nextBtn === 'NO' ? false : true)"
                    >Next</v-btn>
                    <v-btn 
                      outlined
                      :color="data.MainColor"
                      class="ma-2 mt-2"
                      dark
                      depressed
                      elevation="5"
                      @click="finaliseForm(step.stepno -1)" 
                      v-if="step.stepno == (data.steps.length - 1) && (step.submitBtn === 'NO' ? false : true)"
                    >Submit</v-btn>
                </v-row>
                <!-- <v-row class="ma-1">
                    <v-spacer></v-spacer>
                    <v-btn 
                      outlined
                      :color="data.MainColor"
                      class="ma-2 mt-2"
                      dark
                      depressed
                      elevation="5"
                      @click="PrintSubmission"
                      v-if="step.stepno == data.steps.length && !data.Suspended"
                    >Download Submission</v-btn>
                    <v-spacer></v-spacer>
                </v-row> -->
                <v-row class="ma-1">
                  <v-spacer></v-spacer>
                  <div>
                    <Zendesk />
                    <!-- Click Purple Support button to the left for help! -->
                    <!-- <a href="mailto:support@ownurgoal.zendesk.com" target="blank">
                    Customer Service</a> for help.  -->
                  </div>
                  <v-spacer></v-spacer>
                </v-row>
              </v-stepper-content>
            </v-stepper-items>
            </v-stepper>
          </v-container>   
        </v-card>
    </v-card>
  </v-container>
</template>

<script>
import functions from "../Data/Functions"
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { authComputed, getUser, getuserDetails, getaccessCode } from "../veux/helpers";
import Zendesk from '../components/Zendesk'

export default {
  components: { 
    'VFormBase': () => import('@/components/vFormBase'),
    Zendesk
  },
  props: {
        Params: {
            Type: Object,
            Required: true, 
        },
    },
  data() {
    return {
      currentStep: 1,
      data: {},
      isLoading: true,
      files: [],
      StepPDFs: [],
      pdf: null,
      filename: 'My Submission',
      quality: 1, // Higher the better but larger file
    }
  },
  watch: {},
  async mounted() {
    this.$toast.info(`Loading Form - Please Wait !`);
    //Initialise pdf
    this.pdf = new jsPDF('p', 'mm', 'a4', true);
    await functions.GetToken()
    // Load the Portal Required
    this.data = await functions.GetSchemaFunction( 'INIT', this.Params)
    this.isLoading = false
  },
  methods: {
    savePage2PDF(page) {
        html2canvas(page,
            { scale: this.quality }
        ).then(canvas => {
            this.pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
            this.pdf.addPage()
        });
    },
    finaliseForm(step) {
      if (this.$refs.stepForm[step].validate()) {
        if (this.data.steps[(step)].PostStep) {
              this.data.steps[(step)].PostStep(this.data.steps[(step)], this.data, this)
        }
        this.EndProcess()
      }
    },
    validateStepForm(step) {
      if (this.$refs.stepForm[step].validate()) {
            // Check if this step has any PostStep requirements
            if (this.data.steps[(step)].PostStep) {
              this.data.steps[(step)].PostStep(this.data.steps[(step)], this.data)
            }
            // Check if next step has any PreStep requirements
            if (this.data.steps[(step+1)].PreStep) {
              this.data.steps[(step+1)].PreStep(this.data.steps[(step+1)], this.data)
            }
            this.next()
        }
    },
    next() {
      this.savePage2PDF(document.body)
      this.currentStep++;
    },
    previous() {
      this.currentStep--;
    },
    async handleInput( ev ){
        // ev breaks down to:
          // Key or Field Name: ev.key 
          // Value: ev.value
          // Data: ev.data
          // Current Object: ev.obj => 
                          // ev.obj.key, ev.obj.value, ev.obj.schema
          // currentstep schema = ev.schema
      // Portal = this.data
      let portal = this.data

      if (ev.obj.schema.onInput) {
        ev.obj.schema.onInput(ev, portal, this)
      }
    },
    async log (val) {
        // Function to handle click events in the model - see 2 examples 
        let { on, key, obj, params, schema } = val

        // check 'click' is from prependInner Icon (Print) at key 'subgroups.content'  
        if (on === 'click' && key === 'subgroups.content' && (params && params.tag) === 'prepend-inner') {
            window.print()      
        }

        // check 'click' is from from appendIcon at key password
        if (on === 'click' && key === 'password' && (params && params.tag) === 'append') { 
            // toggle visibility of password control
            obj.schema.type === 'password' ? obj.schema.appendIcon = 'lock' : obj.schema.appendIcon = 'visibility'
            obj.schema.type = obj.schema.type === 'password' ? 'text' : 'password'
        }

        if (on === 'click' && obj.schema.onClick ) {
          await obj.schema.onClick(val, this)
        }
            
    },
    async EndProcess() {
        let payload = null
        this.savePage2PDF(document.body)
        payload = await functions.saveData(this.data)
        if (window.location.hostname === 'localhost') {
          console.log(payload)
        }
        if (payload) {
          let result = await functions.LoadData(payload);
          if (result.status == 200) {
            this.currentStep++;
          } 
        } else {
          this.currentStep++;
        }
    },
    PrintSubmission() {
      html2canvas(document.body,
            { scale: this.quality }
        ).then(canvas => {
            this.pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
            this.pdf.save(this.filename);
        });
    }
  },
  computed: {
    ...authComputed,
    ...getUser,
    ...getuserDetails,
    ...getaccessCode
  },
};
</script>

<style>
/*
.v-stepper__step {
  flex: 1 1;
}

.v-stepper_header {
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
} */

/* INFO-SCOPED: Don't use '<style scoped>' because scoped CSS is inside a child-component not accessable */
  /* CSS Item --- set all items  */
  /* #form-base-slot h4 { font-size: 1rem; font-weight:normal; display: inline-block; width:100%; }
  #form-base-slot .item { padding:0.5rem; border: 1px dotted #a2bdf062}
  #form--slot .slot { width: 100%; padding:2px;font-size: 0.9rem;font-weight: 400; color:#9e7506; background-color: #fffacd; border: 1px dotted #a2bdf062}
  #form--slot .slot-label { color:#1976d2; } */

/* .continue {
  align-content: flex-end;
} */
</style>

